import { render, staticRenderFns } from "./UserMenuDropdown.vue?vue&type=template&id=bf31ff58&scoped=true&"
import script from "./UserMenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./UserMenuDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./UserMenuDropdown.vue?vue&type=style&index=0&id=bf31ff58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf31ff58",
  null
  
)

export default component.exports